import { makeStyles, Paper, Typography } from '@material-ui/core';
import React from 'react';
import { Route, Switch } from 'react-router';

import RouterTabs from '../../Common/RouterTabs';
import CoreToolbar from '../../Common/Toolbar';
import AccidentDefinitionListItem from './accident-definition-list';
const useStyles = makeStyles(theme => ({
  tabContainer: {
    display: 'grid',
    borderRadius: 0,
    backgroundColor: theme.palette.grey[100],
  },
  routerTabs: {
    maxWidth: '100%',
  },
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function Index() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CoreToolbar>
        <Typography variant="h6" color="inherit" className="text-bold">
          Kaza Tanımları
        </Typography>
      </CoreToolbar>
      <Paper className={`${classes.tabContainer}`} elevation={3}>
        <RouterTabs rootPath="/definitions/accident-definitions" tabs={AccidentDefinitionListItem} className={classes.routerTabs} />
      </Paper>
      <Switch>
        {AccidentDefinitionListItem.map(({ path, Component }) => (
          <Route key={path} path={`/definitions/accident-definitions/${path}`} exact>
            <Component />
          </Route>
        ))}
      </Switch>
    </div>
  );
}
